import React from 'react'


const Teaser = ({
  title,
  region,
  path,
  ...props
 }) => (
  <article>
            </article>
)

export default Teaser;
